import React from 'react';
import './styles.scss';
import Element from './Element';

const { article, pageLoadId } = window.__STATE__ || {
  article: {
    id: null,
    resolved_id: null
  },
  pageLoadId: null
}

export default () => (
    <Element
        synArticleId={article.id}
        resolvedId={article.resolved_id}
        pageLoadId={pageLoadId}
    />
)
